/********
	* COMPONENT: USE THIS COMPONENT TO MANAGE CHILD COMPONENT.
		#. APPEND MEDIA IN PROVIDED REIGN.
		#. PLAY MEDIA ON PLAYER ACCORDING TO GIVEN TIME.
		#. .... .... .... ....
	* @AUTHOR: IMPRESSICO(fb/gshukla67).
	* DATE: 22/02/2018.
	* UPDATE: --/--/----.
*/

import { Component, OnInit, Input, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToasterService } from 'angular2-toaster';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import * as _ from 'lodash';

@Component({
  selector: 'demo-preview-on-region',
  styleUrls: [('./demo-preview-on-region.scss')],
  templateUrl: './demo-preview-on-region.html'
})
export class DemoPreviewOnRegionComponent implements OnInit, AfterViewInit {

  // public error = '';
  public duration = 6000;
  public loading = false;
  public finalDuration: number;
  public mediaInformation: any;
  public isEnabledAudio: boolean;
  public isPreviewEnd: boolean=true;
  public currentMediaInformation: any[];

  @Input() END: number;
  @Input() MEDIA: any[];
  @Input() AUDIOSTATUS: boolean;

  @ViewChild('campaignVideoPlayer') cpnVideoPlayer: ElementRef;

  constructor(
    private _activeModal: NgbActiveModal,
    private _toasterService: ToasterService
  ) {
    // console.log('MediaPreviewOnRegion: ', this.mediaInformation);
  }

  ngOnInit(): void {
    this.finalDuration = this.END;
    this.mediaInformation = this.MEDIA;
    this.isEnabledAudio = this.AUDIOSTATUS;
    this.playMediaInRegion();
  }

  ngAfterViewInit() {
    this.cpnVideoPlayer.nativeElement.style.display = "none";

    // END AUDIO.
    Observable.interval(this.finalDuration)
      .take(1)
      .subscribe((order) => {
        this.mediaInformation = [];
        this.cpnVideoPlayer.nativeElement.pause();
        this.isPreviewEnd = true;
      });
  }

  playMediaInRegion(): void {
    /* https://stackoverflow.com/questions/42079800/rxjs-observable-changing-interval */
    Observable.interval(this.duration)
      .take(this.mediaInformation.globalRegionContentPlaylistContents.length)
      .map((order) => order + 1)
      .subscribe((order) => {
        let audio = (!this.isEnabledAudio) ? (!this.mediaInformation.isAudioEnabled) : this.isEnabledAudio;
        _.forEach(this.mediaInformation.globalRegionContentPlaylistContents, (media, key) => {
          if (media.order == order) {
            this.isPreviewEnd = false;
            this.duration = 6000;
            this.currentMediaInformation = media;
            if (media.media_type == 'VIDEO') {
              this.cpnVideoPlayerManager(audio, media);
            }
            else {
              this.cpnVideoPlayer.nativeElement.style.display = "none";
              this.cpnVideoPlayer.nativeElement.pause();
            }
          }
        });
      });
  }

  cpnVideoPlayerManager(udo: boolean = true, evn: any): void {
    if (!_.isUndefined(evn)) {
      this.cpnVideoPlayer.nativeElement.style.display = "block";
      this.cpnVideoPlayer.nativeElement.src = evn.media_url;
      this.cpnVideoPlayer.nativeElement.muted = udo;
      this.cpnVideoPlayer.nativeElement.play();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/shared/components/demo-preview-on-region/demo-preview-on-region.component.ts